import { useEffect, useMemo, useRef } from "react";

const useColsEffect = (grid, names) => {
    const shouldRefresh = useRef(false);

    useEffect(() => {
        const gridObj = grid.current;
        if (!gridObj) return;

        if (!shouldRefresh.current) {
            shouldRefresh.current = true;
            gridObj.setProperties({ columns: gridObj.columns }, false);
            // setTimeout to execute after all templates have updated
            setTimeout(() => {
                shouldRefresh.current = false;
                gridObj.refresh();
            }, 0);
        }
    }, [names]);
};

const useTreegridColsEffect = (awsOptions, treeGrid, names, t) => {
    /* Similar to the function above, but with awsOptions */
    const shouldRefresh = useRef(false);

    useEffect(() => {
        const treeGridObj = treeGrid.current;
        if (!treeGridObj) return;

        if (!shouldRefresh.current) {
            shouldRefresh.current = true;
            treeGridObj.setProperties({ columns: treeGridObj.columns }, !treeGridObj.grid);
            // setTimeout to execute after all templates have updated
            setTimeout(() => {
                shouldRefresh.current = false;
                if (treeGridObj.grid) treeGridObj.grid.refresh();
            }, 0);
        }
        if (awsOptions && awsOptions.current) awsOptions.current.t = t;
    }, [names, t]);
};

const useGridRef = (grid, data) => {
    /* This hook returns a function that is run when the grid object is created (with the object as an argument)
    * or when is deleted (with a null argument)
    * If at the time we run this hook we have a valid "grid.current" object (maybe the data has changed), assign the dataSource to it,
    * and return a function to set the reference to null when the grid is deleted.
    * If at the time we run this hook we dont have a valid grid object (it has not been created, we are on first render), we can't
    * assign the dataSource to it, so return a function that will assign the datasource when the grid is created.
    */
    const gridRef = useMemo(() => {
        const gridObj = grid.current;
        if (gridObj) {
            gridObj.setProperties({ dataSource: data }, false);
            return (obj) => grid.current = obj;
        }

        return (obj) => {
            obj && obj.setProperties({ dataSource: data }, false);
            return grid.current = obj;
        };
    }, [grid, data]);
    return gridRef;
};

export { useColsEffect, useTreegridColsEffect, useGridRef };
